import { Box, Grid } from '@mui/material';
import { CurrencyProvider } from '@procureai/ui-mui';
import { useFormContext } from 'react-hook-form';

import { DetailsForm } from '../DetailsForm/DetailsForm';
import { QuoteDetailsLineItemsForm } from '../QuoteDetailsLineItemsForm/QuoteDetailsLineItemsForm';
import { TermsForm } from '../TermsForm/TermsForm';

import { QuoteFormData } from './QuoteDetailsForm.schema';

export const QuoteDetailsForm = () => {
  const { watch } = useFormContext<QuoteFormData>();

  const watchCurrency = watch('quote.currency');

  return (
    <CurrencyProvider value={watchCurrency}>
      <div>
        <Grid
          container
          direction="row"
          spacing={3}
          sx={{
            justifyContent: 'flex-start',
            alignItems: 'stretch',
            alignContent: 'flex-start',
          }}
        >
          <Grid
            container
            spacing={3}
            size={{
              xs: 12,
              md: 6,
            }}
            sx={{
              alignContent: 'flex-start',
            }}
          >
            <DetailsForm />
          </Grid>
          <Grid
            container
            size={{
              xs: 12,
              md: 6,
            }}
          >
            <TermsForm />
          </Grid>
        </Grid>
        <Box
          sx={{
            mt: 6,
          }}
        >
          <QuoteDetailsLineItemsForm />
        </Box>
      </div>
    </CurrencyProvider>
  );
};
